import { render, staticRenderFns } from "./AnalysisTable.vue?vue&type=template&id=22e72146&scoped=true"
import script from "./AnalysisTable.vue?vue&type=script&lang=js"
export * from "./AnalysisTable.vue?vue&type=script&lang=js"
import style0 from "./AnalysisTable.vue?vue&type=style&index=0&id=22e72146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e72146",
  null
  
)

export default component.exports